import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import store from '@src/store/index.js';
import BurgerIcon from '../BurgerIcon/BurgerIcon.jsx';
import Nav from './Nav/Nav.jsx';
import natsLogoWhiteSvg from '@assets/nats-logo-white.svg';

import './Header.css';

export default function Header(props) {
  const navRef = useRef(null);
  const navActive = store.navActive.use();
  return (
    <div className={classNames('headerContainer', props.className)}>
      <div
        className={classNames('headerOverlay', navActive && 'active')}
        onClick={() => store.toggleNav(false)}
      />
      <header className="headerFrame">
        <div className="headerBrandWrapper">
          <img
            className="headerBrandLogo"
            alt="NATS Logo"
            src={natsLogoWhiteSvg}
            draggable="false"
          />
        </div>
        <div className="headerTitleWrapper">
          <h1 className="headerTitle">{props.title}</h1>
        </div>
        <div className="headerNavWrapper">
          <button
            className={classNames('headerNavBtn', navActive && 'active')}
            onClick={() => store.toggleNav()}
          >
            <BurgerIcon className="headerNavBurgerIcon" active={navActive} />
          </button>
          <CSSTransition
            nodeRef={navRef}
            in={navActive}
            timeout={220}
            classNames="fade-scale-200"
            unmountOnExit
          >
            <Nav className="headerNav" innerRef={navRef} />
          </CSSTransition>
        </div>
      </header>
    </div>
  );
}
